import { CaptivePortalTemplateConfig } from './types';
import {
  BasicTemplate,
  ModernTemplate,
  MinimalTemplate,
  CorporateTemplate,
  SplitTemplate,
  CompactTemplate,
} from './templates/index';
import {
  CaptivePortalTemplate,
  CaptivePortalTemplateBasic,
  CaptivePortalTemplateMinimal,
  CaptivePortalTemplateModern,
  CaptivePortalTemplateCorporate,
  CaptivePortalTemplateSplit,
  CaptivePortalTemplateCompact,
} from '@lib/model/captive-portal-template-enum';
import { CaptivePortalTemplateData } from '@lib/model/captive-portal-template-data-model';
import { BasicTemplateDataKeys } from './templates/BasicTemplate';
import { ModernTemplateDataKeys } from './templates/ModernTemplate';
import { MinimalTemplateDataKeys } from './templates/MinimalTemplate';
import { CorporateTemplateDataKeys } from './templates/CorporateTemplate';
import { SplitTemplateDataKeys } from './templates/SplitTemplate';
import { CompactTemplateDataKeys } from './templates/CompactTemplate';

export const availableTemplates: CaptivePortalTemplateConfig<keyof CaptivePortalTemplateData>[] = [
  {
    id: CaptivePortalTemplateBasic,
    name: 'Basic',
    description: 'A simple, clean layout with centered form and logo, contained in a card',
    component: BasicTemplate,
    keys: BasicTemplateDataKeys,
  },
  {
    id: CaptivePortalTemplateModern,
    name: 'Modern',
    description:
      'The logo, title and content are centered directly on the background, with a card containing the input fields',
    component: ModernTemplate,
    keys: ModernTemplateDataKeys,
  },
  {
    id: CaptivePortalTemplateMinimal,
    name: 'Minimal',
    description: 'Ultra-clean design with borderless inputs and minimal styling',
    component: MinimalTemplate,
    keys: MinimalTemplateDataKeys,
  },
  {
    id: CaptivePortalTemplateCorporate,
    name: 'Corporate',
    description: 'Professional two-column layout with gradient sidebar and business-focused design',
    component: CorporateTemplate,
    keys: CorporateTemplateDataKeys,
  },
  {
    id: CaptivePortalTemplateSplit,
    name: 'Split',
    description: 'Full-screen split layout with branded left side and clean form on the right',
    component: SplitTemplate,
    keys: SplitTemplateDataKeys,
    editorScale: 0.5,
  },
  {
    id: CaptivePortalTemplateCompact,
    name: 'Compact',
    description: 'Space-efficient single-column design optimized for smaller screens',
    component: CompactTemplate,
    keys: CompactTemplateDataKeys,
  },
];

export const getTemplateById = (
  id: CaptivePortalTemplate | undefined,
): CaptivePortalTemplateConfig<keyof CaptivePortalTemplateData> | undefined => {
  return availableTemplates.find((template) => template.id === id);
};

export const getDefaultTemplateData = () => ({
  header: 'Welcome to our WiFi',
  content: 'Please provide your information to connect to the internet.',
  buttonText: 'Connect to Internet',
  termsText: 'I agree to the terms and conditions of use.',
  showEmail: true,
  showName: true,
  requireEmail: false,
  requireName: false,
});
